// extracted by mini-css-extract-plugin
export default {"link":"link--R3bpd","arrow":"arrow--R3bpd"};